<template>
    <!-- 单选框组二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-radio-group v-model="currentModel"
                      :disabled="isDisabled"
                      :style="{
                        marginTop: displayType == 'block' ? '-5px' : '0'
                      }">
        <el-radio v-for="(item,index) in options"
                  :style="{ display: displayType, 
                            lineHeight: displayType == 'block' ? '20px' : '20px',
                            marginBottom: displayType == 'block' ? '5px' : '0'}"
                  :key="index"
                  :label="item.label">
                  {{item.value}}
        </el-radio>
      </el-radio-group>
    </div>
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ]
}

</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemRadio.vue